import React, { useEffect, useState } from "react";
import Table, {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
} from "../../../table/Table"; // new
import {getAuthorization} from "../../../../axios/AxiosAut";
import { useNavigate } from "react-router-dom";
import {
  setItemsTransactions,
  SetCurrentID,
} from "../../../../redux/slices/item/itemSlice";
import { useDispatch, useSelector } from "react-redux";

function ItemsTransactionDetailsTableData(ID) {
  const dispatch = useDispatch();
  const ItemsTransactions = useSelector(
    (state) => state.item.ItemsTransactions
  );
  const CurrentID = useSelector((state) => state.item.CurrentID);
  const ItemDetails = useSelector((state) => state.item.ItemDetails);

  const getTransactionDetailData = () => {
    getAuthorization()
      .get(`product/get_product_orders/${ID.Id}/`)
      .then((res) => {
        console.log("ItemsTransaction", res.data);
        dispatch(setItemsTransactions(res.data));
        dispatch(SetCurrentID(ID.Id));
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  useEffect(() => {
    console.log("id  Transaction..", ID.Id);

    if (ItemsTransactions.length === 0 || CurrentID !== ItemDetails.id) {
      getTransactionDetailData();

      console.log("API called....ItemsTransaction.");
      console.log("id  Transaction..", ID.Id);
      console.log("ItemsTransaction.....", ItemsTransactions);
    }
  }, []);
  const data = ItemsTransactions;
  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Country",
        accessor: "country",
      },
      {
        Header: "Postal Code",
        accessor: "post_code",
      },
      {
        Header: "Business Type",
        accessor: "business_type",
      },
      {
        Header: "Action",
        Cell: (value) => (
          <button>
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 12.1815C15 13.8391 13.654 15.1881 12 15.1881C10.346 15.1881 9 13.8391 9 12.1815C9 10.5239 10.346 9.17498 12 9.17498C13.654 9.17498 15 10.5239 15 12.1815ZM24 11.7315C24 11.7315 19.748 20.199 12.015 20.199C4.835 20.199 0 11.7315 0 11.7315C0 11.7315 4.446 4.16406 12.015 4.16406C19.709 4.16406 24 11.7315 24 11.7315ZM17 12.1815C17 9.41851 14.757 7.17061 12 7.17061C9.243 7.17061 7 9.41851 7 12.1815C7 14.9445 9.243 17.1924 12 17.1924C14.757 17.1924 17 14.9445 17 12.1815Z"
                fill="#1F78B4"
              />
            </svg>
          </button>
        ),
      },
    ],
    []
  );

  return (
    <div className="">
      <main className="max-w-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="mt-1">
          <Table columns={columns} data={data} text="Transactions" />
        </div>
      </main>
    </div>
  );
}

export default ItemsTransactionDetailsTableData;
